import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import type { ProcessingLog } from "./types";

interface ProcessingHistoryProps {
  logs: ProcessingLog[];
}

export function ProcessingHistory({ logs }: ProcessingHistoryProps) {
  return (
    <Card className="w-full">
      <CardHeader className="p-4">
        <CardTitle className="text-lg sm:text-xl">Behandlingshistorikk</CardTitle>
        <CardDescription className="text-sm">
          Oversikt over hvordan dine data har blitt behandlet
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4">
        <ScrollArea className="h-[200px] sm:h-[300px] rounded-md border p-4">
          {logs.length > 0 ? (
            <div className="space-y-4">
              {logs.map((log) => (
                <div key={log.id} className="border-b pb-4 last:border-0">
                  <p className="font-medium text-sm sm:text-base">{log.processing_purpose}</p>
                  <p className="text-xs sm:text-sm text-muted-foreground">
                    Type: {log.request_type}
                  </p>
                  <p className="text-xs sm:text-sm text-muted-foreground">
                    Tidspunkt: {new Date(log.created_at).toLocaleString('no-NO')}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-sm text-muted-foreground">
              Ingen behandlingshistorikk tilgjengelig
            </p>
          )}
        </ScrollArea>
      </CardContent>
    </Card>
  );
}